import React, { useState, useLayoutEffect } from "react";
import moment from "moment-timezone";
import cx from "classnames";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
type OnChange = (timestamp: number) => void;

const nullOp = () => {};

const GCTimePicker = ({
	onChange,
	value,
	dayTimestamp,
	timezone,
	debounce = 300,
}: {
	onChange: OnChange;
	value: number;
	dayTimestamp: number;
	timezone: string;
	debounce?: number;
}) => {
	const [startHour, setStartHour] = useState(0);
	const [hour, setHour] = useState(value);
	const [hours, setHours] = useState([]);
	const [subject$, setSubject] = useState(null as Subject<number>);

	useLayoutEffect(() => {
		const subject$ = new Subject<number>();

		const subscription = subject$.pipe(debounceTime(debounce)).subscribe(hour => {
			setHour(hour);
			onChange(hour);
		});

		setSubject(subject$);

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	useLayoutEffect(() => {
		const now = moment.tz(timezone);
		let startHour = 0;
		if (now.unix() >= dayTimestamp) {
			startHour = parseInt(now.format("k"));
		}

		setStartHour(startHour);

		let hours = [];
		for (let index = startHour; index < 24; index++) {
			hours.push(index);
		}
		setHours(hours);

		if (hours.indexOf(hour) === -1) {
			setHour(hours[0]);
		}
	}, [dayTimestamp]);

	const onDateChange = e => {
		const hour = parseInt(e.target.value);
		setHour(hour);
		onChange(hour);
	};
	const prevHour = () => {
		setHour(hour - 1);
		subject$.next(hour - 1);
	};
	const nextHour = () => {
		setHour(hour + 1);
		subject$.next(hour + 1);
	};

	const prevDisabled = hour === startHour;
	const nextDisabled = hour === 23;

	return (
		<div className="dayPicker">
			<div className={cx("prev", { disabled: prevDisabled })} onClick={!prevDisabled ? prevHour : nullOp}>
				<div className="icon" />
			</div>
			<div className="current">
				<div className="value">{hour}:00</div>
				<select onChange={onDateChange}>
					{hours.map((hour, index) => (
						<option key={index} value={hour}>
							{hour}:00
						</option>
					))}
				</select>
			</div>
			<div className={cx("next", { disabled: nextDisabled })} onClick={!nextDisabled ? nextHour : nullOp}>
				<div className="icon" />
			</div>
		</div>
	);
};

export default GCTimePicker;
